export default "/images/vendor/flag-icons/flags/1x1/gg.svg?cff3c6217db3d2732657cdbcb24fb702";